import React from "react"
import PropTypes from "prop-types"
import { CmsImage } from "@bw/bits"
import { Gallery as PhotoSwipe, Item } from "react-photoswipe-gallery"
import styled from "styled-components"

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
`

const Gallery = ({ images }) => {
  return (
    <PhotoSwipe
      options={{
        hideAnimationDuration: 0,
        showAnimationDuration: 0,
      }}
    >
      <Grid>
        {images.map((image, i) => (
          <Item
            key={i}
            original={
              image?.localImage?.childImageSharp?.original?.src || image.url
            }
            width={image?.localImage?.childImageSharp?.original?.width}
            height={image?.localImage?.childImageSharp?.original?.height}
          >
            {({ ref, open }) => (
              <div role="button" ref={ref} onClick={open}>
                <CmsImage src={image} alt={image.alt} />
              </div>
            )}
          </Item>
        ))}
      </Grid>
    </PhotoSwipe>
  )
}

Gallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.object),
}

export { Gallery }
